import React, { useState } from "react";
import { Box, CircularProgress, Grid, Skeleton } from "@mui/material";
import useIsSmallScreen from "../utils/useIsSmallScreen";
import LogoRight from "../assets/images/LogoRight.png";
import Voice from "../assets/icons/voice-recognition.png";
import Book from "../assets/icons/book.png";
import "../styles/TopSection.css";
import Header from "../panel/Header";

const TopSection = ({
  searchText,
  setSearchText,
  title,
  cover,
  numberOfBooks,
  numberOfVoices,
  onBack = false,
}) => {
  const IS_SMALL_SCREEN = useIsSmallScreen();
  const [coverIsLoaded, setCoverIsLoaded] = useState(false);
  return (
    <Box sx={{ width: "100%", mb: 1 }}>
      <Header
        title={title}
        searchText={searchText}
        setSearchText={setSearchText}
        onBack={onBack}
        isSmallScreen={IS_SMALL_SCREEN}
      />
      <Grid
        container
        rowSpacing={2}
        columnSpacing={2}
        className="topSection"
        alignItems="stretch"
      >
        <Grid item xs={12} md={1} className="center-item"></Grid>
        <Grid item xs={6} md={8} sx={{ display: "flex" }}>
          <Box
            component="img"
            src={cover}
            alt="read-listen"
            sx={{
              borderRadius: "5px",
              width: "100%",
              height: "auto",
              display: coverIsLoaded ? "block" : "none",
            }}
            onLoad={() => setCoverIsLoaded(true)}
          />
          {!coverIsLoaded && (
            <Skeleton
              variant="rectangular"
              sx={{ width: "90%", height: "85%", minHeight: "50px" }}
            />
          )}
        </Grid>
        <Grid item xs={6} md={1} className="md-homepageCountUpSection">
          <Box className="topSection-countUpSection">
            <Box className="topSection-countUp">
              <img src={Book} alt="book-icon" />
              {numberOfBooks || numberOfBooks === 0 ? (
                <CountUp number={numberOfBooks} />
              ) : (
                <CircularProgress sx={{ margin: "auto" }} color="secondary" />
              )}
            </Box>
            <Box
              className="topSection-countUp"
              sx={{
                mb: 0,
                "&>img": {
                  height: "40%",
                  minHeight: "40px",
                },
              }}
            >
              <img src={Voice} alt="voice-icon" />
              {numberOfVoices || numberOfVoices === 0 ? (
                <CountUp number={numberOfVoices} />
              ) : (
                <CircularProgress sx={{ margin: "auto" }} color="secondary" />
              )}
            </Box>
          </Box>
        </Grid>
        {!IS_SMALL_SCREEN && (
          <Grid item sm={6} md={1} className="topSection-rightCover">
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
                borderRadius: "5px",
                width: "100%",
                overflow: "hidden",
                p: 1,
              }}
            >
              <Box
                component="img"
                src={LogoRight}
                alt="pirhani-ebook"
                className="md-homepageCardPhoto topSection-rightCoverImg"
              />
            </Box>
          </Grid>
        )}
        <Grid item xs={12} md={1} className="center-item"></Grid>
      </Grid>
    </Box>
  );
};

export default TopSection;

function CountUp({ number }) {
  const DELAY = number < 5 ? 800 : 4000;
  const [counter, setCounter] = React.useState(0);

  React.useEffect(() => {
    let repeatCount = setInterval(() => {
      setCounter((prev) => {
        if (prev < number) {
          return prev + 1;
        }
        clearInterval(repeatCount);
        return prev;
      });
    }, Math.floor(DELAY / number));
  }, [DELAY, number]);

  return <span className="md-countUpText">{counter}</span>;
}
